import React, { useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";

function Login({ setUserName }) {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [qrCode, setQrCode] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");


  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // 🔥 Hardcoded API URL for production
      const apiUrl = "https://testone.conversationaily.ai";
      // const apiUrl = 'https://consult.conversationaily.ai'

      const response = await axios.post(`${apiUrl}/api/users/login`, {
        email: username,
        password,
      });

      if (response.data.access_token) {
        localStorage.setItem("accessToken", response.data.access_token);
        localStorage.setItem(
          "userName",
          `${response.data.user.first_name} ${response.data.user.last_name}`
        );
        localStorage.setItem("qrCode", response.data.qr_code);
        localStorage.setItem("doctorId", response.data.doc_id);
        localStorage.setItem("userId", response.data.user.id);
        setMessage("Login successful");
        setUserName(`${response.data.user.first_name} ${response.data.user.last_name}`);
        setQrCode(response.data.qr_code);

        const organization = response.data.user.organization || "";
        localStorage.setItem("organization", organization);

        const smbtOrganizations = [
          "SMBT",
          "SMBT Institute of Medical Sciences and Research Centre",
          "SMBT IMSRC"
        ];

        if (
          response.data.user.role === "student" &&
          smbtOrganizations.includes(organization)
        ) {
          window.location.assign("/smbt/intern");
        } else if (response.data.test_history_status === true) {
          navigate("/reports");
        } else {
          navigate("/cases");
        }

      } else {
        setError(response.data.message);
      }
    } catch (error) {
      setError(error.response.data.message || "Invalid credentials, please try again");
    }
  };

  return (
    <div>
      <nav className="bg-white w-full">
        <div className="mx-auto px-2 sm:px-6 lg:px-8">
          <div className="relative flex items-center justify-between h-16">
            <div className="flex-shrink-0 flex items-center justify-center">
              <img
                className="h-8 w-auto"
                src="./logo.png"
                alt="Your Company"
                id="logo"
              />
            </div>
          </div>
        </div>
      </nav>
      <div className="flex w-full flex-wrap">
        <div className="flex w-full flex-col md:w-1/2 lg:w-1/3">
          <div className="my-auto flex flex-col justify-center px-6 pt-8 sm:px-24 md:justify-start md:px-8 md:pt-0 lg:px-12">
            <p className="text-center text-3xl font-bold">Welcome</p>
            <p className="mt-2 text-center">Login with your authorized credentials.</p>
            <form className="flex flex-col pt-3 md:pt-8" onSubmit={handleSubmit}>
              <div className="flex flex-col pt-4">
                <div className="relative flex overflow-hidden rounded-lg border focus-within:border-transparent focus-within:ring-2 transition focus-within:ring-blue-600">
                  <span className="inline-flex items-center border-r border-gray-300 bg-white px-3 text-sm text-gray-500 shadow-sm">
                    <svg
                      width="15"
                      height="15"
                      fill="currentColor"
                      viewBox="0 0 1792 1792"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M1792 710v794q0 66-47 113t-113 47h-1472q-66 0-113-47t-47-113v-794q44 49 101 87 362 246 497 345 57 42 92.5 65.5t94.5 48 110 24.5h2q51 0 110-24.5t94.5-48 92.5-65.5q170-123 498-345 57-39 100-87zm0-294q0 79-49 151t-122 123q-376 261-468 325-10 7-42.5 30.5t-54 38-52 32.5-57.5 27-50 9h-2q-23 0-50-9t-57.5-27-52-32.5-54-38-42.5-30.5q-91-64-262-182.5t-205-142.5q-62-42-117-115.5t-55-136.5q0-78 41.5-130t118.5-52h1472q65 0 112.5 47t47.5 113z"></path>
                    </svg>
                  </span>
                  <input
                    type="text"
                    id="username"
                    name="username"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    className="w-full flex-1 appearance-none border-gray-300 bg-white py-2 px-4 text-base text-gray-700 placeholder-gray-400 focus:outline-none"
                    placeholder="Email Address"
                    autoComplete="current-username"
                    required
                  />
                </div>
              </div>
              <div className="mb-12 flex flex-col pt-4">
                <div className="relative flex overflow-hidden rounded-lg border focus-within:border-transparent focus-within:ring-2 transition focus-within:ring-blue-600">
                  <span className="inline-flex items-center border-r border-gray-300 bg-white px-3 text-sm text-gray-500 shadow-sm">
                    <svg
                      width="15"
                      height="15"
                      fill="currentColor"
                      viewBox="0 0 1792 1792"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M1376 768q40 0 68 28t28 68v576q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-576q0-40 28-68t68-28h32v-320q0-185 131.5-316.5t316.5-131.5 316.5 131.5 131.5 316.5q0 26-19 45t-45 19h-64q-26 0-45-19t-19-45q0-106-75-181t-181-75-181 75-75 181v320h736z"></path>
                    </svg>
                  </span>

                  <input
                    type={showPassword ? "text" : "password"}
                    id="password"
                    name="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="w-full flex-1 appearance-none border-0 bg-white py-2 px-4 pr-12 text-base text-gray-700 placeholder-gray-400 focus:outline-none"
                    placeholder="Password"
                    autoComplete="current-password"
                    required
                  />

                  <button
                    type="button"
                    onClick={() => setShowPassword((prev) => !prev)}
                    className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700 focus:outline-none"
                    aria-label={showPassword ? "Hide password" : "Show password"}
                  >
                    {showPassword ? (
                      // Eye Off
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M3 3l18 18" />
                        <path d="M10.58 10.58a2 2 0 102.83 2.83" />
                        <path d="M9.88 5.09A9.77 9.77 0 0112 5c5 0 8.33 5 9.94 6.65a1 1 0 010 .7 13.16 13.16 0 01-1.64 2.85" />
                        <path d="M6.61 6.61C4.62 7.95 3.35 9.82 3 12c.73 2 4 7 9 7a9.77 9.77 0 004.12-.91" />
                      </svg>
                    ) : (
                      // Eye
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M2.06 12.35a1 1 0 010-.7C3.67 7.7 7.53 5 12 5s8.33 2.7 9.94 6.65a1 1 0 010 .7C20.33 16.3 16.47 19 12 19s-8.33-2.7-9.94-6.65z" />
                        <circle cx="12" cy="12" r="3" />
                      </svg>
                    )}
                  </button>
                </div>

                <div className="mt-2 flex justify-end">
                  <Link
                    to="/forgot-password"
                    className="text-sm font-medium text-blue-600 hover:underline"
                  >
                    Forgot Password?
                  </Link>
                </div>
              </div>

              <button
                type="submit"
                className="w-full rounded-lg bg-orange-400 px-4 py-2 text-center text-base font-semibold text-white shadow-md transition ease-in hover:bg-orange-600 focus:outline-none focus:ring-2"
              >
                <span className="w-full"> Submit </span>
              </button>

              <p className="mt-2 text-center text-sm">
                New user?{" "}
                <Link
                  to="/register"
                  className="font-medium text-blue-600 hover:underline"
                >
                  Register here
                </Link>
              </p>
            </form>
            {error && <p className="text-red-500 text-center mt-4">{error}</p>}
            {message && <p className="text-green-500 text-center mt-4">{message}</p>}
          </div>
        </div>
        <div className="pointer-events-none hidden select-none bg-black shadow-2xl md:block md:w-1/2 lg:w-2/3 rounded-md">
          <img
            className="h-screen w-full object-cover opacity-90 rounded-md"
            src="https://assets.lummi.ai/assets/QmcqqnDFFwgvV4JoQ2VnMw3ECupGVnRGLj5294JqdMxZfj?auto=format&w=1500"
            alt="login"
          />
        </div>
      </div>
    </div>
  );
}

export default Login;
